import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import { Avatar } from '@backstage/core-components';
import Box from '@material-ui/core/Box';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Link } from '@backstage/core-components';
import { Team } from '@internal/schemas-common';
import Typography from '@material-ui/core/Typography';

import { Divider, Grid } from '@material-ui/core';

const CardTitle = (props: { title: string; picture: string; link: string }) => (
  <Box display="flex" alignItems="center">
    <Avatar displayName={props.title} picture={props.picture} />
    <Box ml={1}>
      <Link to={props.link}> {props.title} </Link>
    </Box>
  </Box>
);

export const AllTeamsAccordion = ({ teams }: { teams: Team[] | undefined }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6" color="textPrimary">
          {`All Teams (${teams?.length})`}
        </Typography>
      </AccordionSummary>
      <Divider />
      <AccordionDetails>
        <Grid container>
          {teams?.map(team => {
            return (
              <Grid key={team.nameInGitlab} item xs={12} md={2}>
                <CardTitle
                  title={team.name}
                  picture={team.picture}
                  link={team.portalTeamPageHref}
                />
              </Grid>
            );
          })}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};
